import React from 'react'
import { Sparkles, X } from 'lucide-react'
import {
  NEWS_EDITOR_VIEWER_ZOOM,
  shouldShowNewsTour,
  dismissNewsTourWithoutViewing,
  setNewsEditorViewerZoomSnooze,
  isNewsEditorViewerZoomSnoozed,
} from '../config/newsTours'
import { forceTour } from '../hooks/usePageTour'

/**
 * Aviso de novedades en el editor PDF (no dispara el tour completo de la página).
 */
export default function EditorNewsBanner({ enabled, onUpdate }) {
  if (!enabled) return null
  if (isNewsEditorViewerZoomSnoozed()) return null
  if (!shouldShowNewsTour(NEWS_EDITOR_VIEWER_ZOOM)) return null

  const handleVerNovedades = () => {
    forceTour(NEWS_EDITOR_VIEWER_ZOOM.id)
  }

  const handleMasTarde = () => {
    setNewsEditorViewerZoomSnooze()
    onUpdate?.()
  }

  const handleCerrar = () => {
    dismissNewsTourWithoutViewing(NEWS_EDITOR_VIEWER_ZOOM)
    onUpdate?.()
  }

  return (
    <div
      className="mb-4 rounded-xl border border-primary-200 bg-primary-50/90 px-4 py-3 shadow-sm"
      role="region"
      aria-label="Novedades del aplicativo"
    >
      <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
        <div className="flex items-start gap-2 min-w-0">
          <Sparkles className="h-5 w-5 text-primary-600 flex-shrink-0 mt-0.5" aria-hidden />
          <p className="text-sm text-gray-800 font-medium">
            Hay cambios nuevos en el aplicativo de firmas
          </p>
        </div>
        <div className="flex flex-wrap items-center gap-2 sm:flex-shrink-0">
          <button
            type="button"
            onClick={handleVerNovedades}
            className="px-3 py-1.5 text-sm font-medium rounded-lg bg-primary-600 text-white hover:bg-primary-700"
          >
            Ver novedades
          </button>
          <button
            type="button"
            onClick={handleMasTarde}
            className="px-3 py-1.5 text-sm font-medium rounded-lg bg-white border border-gray-300 text-gray-700 hover:bg-gray-50"
          >
            Más tarde
          </button>
          <button
            type="button"
            onClick={handleCerrar}
            className="p-1.5 rounded-lg text-gray-500 hover:bg-gray-200/80 hover:text-gray-800"
            title="Cerrar"
            aria-label="Cerrar aviso de novedades"
          >
            <X className="h-4 w-4" />
          </button>
        </div>
      </div>
    </div>
  )
}
